module.exports = __webpack_public_path__ + "static/img/logo-domus.92936a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/logo-domus.png
// module id = 1025
// module chunks = 1